// extracted by mini-css-extract-plugin
module.exports = {"about":"TheHomeAbout_about_1_Nu_","aboutLogo":"TheHomeAbout_aboutLogo_3b87T","spinAround":"TheHomeAbout_spinAround_klcdL"};